// extracted by mini-css-extract-plugin
module.exports = {"actions":"ResourceFormActions_actions__1A7ZO","buttonPadding":"ResourceFormActions_buttonPadding__3qhkj"};